import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-page',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})
export class MaintenancePageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
